import { ColorPicker } from "antd";
import { useState } from "react";

interface AnnotationColorBtnProps {
  changeColor: (color: string) => void;
  currentColor: string;
}

const AnnotationColorBtn = ({
  changeColor,
  currentColor,
}: AnnotationColorBtnProps) => {
  const [haxColor, setHaxColor] = useState<string>(currentColor || "#285F3D");

  const handleColor = (metaColor: any) => {
    const value = metaColor.toHex();
    setHaxColor("#" + value);
    changeColor("#" + value);
  };

  return (
    <ColorPicker
      defaultValue={haxColor}
      onChangeComplete={handleColor}
      size="small"
    />
  );
};

export default AnnotationColorBtn;
